// extracted by mini-css-extract-plugin
module.exports = {"container":"Card_container__kApE_","svgCircle":"Card_svgCircle__27tHy","text":"Card_text__bHsYU"};